import { createClient } from '@supabase/supabase-js';
// src/utils/loadProducts.js

let cachedData = null;
let lastFetchTime = 0;
const CACHE_DURATION = 1000 * 60 * 2; // 2 minutes

const SUPABASE_URL = 'https://mmcbzhkzvuhqocsdzsyr.supabase.co';
const SUPABASE_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1tY2J6aGt6dnVocW9jc2R6c3lyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkxMzA1NzYsImV4cCI6MjA2NDcwNjU3Nn0.Keel6zrXCokQBg3G9fpuDHvumLJAG1-jbsAPqh4nQDs'; // Only use anon key on frontend
const supabase = createClient(SUPABASE_URL, SUPABASE_API_KEY);

function slugify(str) {
  return str
    .toString()
    .toLowerCase()
    .normalize('NFD') // split accented letters
    .replace(/\p{Diacritic}/gu, '') // remove accents
    .replace(/[^a-z0-9]+/g, '-') // replace non-alphanumeric with hyphens
    .replace(/^-+|-+$/g, '') // trim hyphens
    .replace(/-{2,}/g, '-'); // collapse multiple hyphens
}

export const loadProducts = async () => {
  const now = Date.now();

  if (cachedData && now - lastFetchTime < CACHE_DURATION) {
    console.log('Using cached product data');
    return cachedData;
  }

  console.log('Fetching fresh product data from Supabase');

  const { data, error } = await supabase
    .from('products')
    .select('*')
    .not('img', 'is', null) // Exclude rows where img is null
    .neq('img', '');        // Exclude rows where img is empty string

  if (error) {
    console.error('Error fetching products:', error);
    return null;
  }

  // Add slug property to each product
  const productsWithSlugs = data.map(product => ({
    ...product,
    slug: slugify(product.name),
  }));

  cachedData = productsWithSlugs;
  lastFetchTime = now;

  return productsWithSlugs;
};